import { Injectable } from '@angular/core';
import { IconSettingsService } from '@progress/kendo-angular-icons';
import { SVGIcon } from '@progress/kendo-svg-icons';
import * as allSVGIcons from '@progress/kendo-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class KendoIconSettingsService extends IconSettingsService {
  private svgDictionary: { [key: string]: SVGIcon } = {
    'x-circle': allSVGIcons.xIcon,
    "caret-alt-down": allSVGIcons.chevronDownIcon,
    "caret-alt-up": allSVGIcons.chevronUpIcon,
  };

  public getSvgIcon(svgIconName: string): SVGIcon {
    return this.svgDictionary[svgIconName] || super.getSvgIcon(svgIconName);
  }
}
